module.exports = __webpack_public_path__ + "img/JLTP_content_N2.08aedca7.svg";